import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class HealthService {

  healthCheck(mid) {
    return http.get(API_URL + `/api/v1/health`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new HealthService();



// WEBPACK FOOTER //
// ./src/service/health.service.js